// Returns required node from obj using desc as search
const getStateNode = (obj, desc) => {
    if (obj!==undefined) {
        const arr = desc.split('.');
        while (arr.length && (obj = obj[arr.shift()]));
        return obj;
    }
  }

export default getStateNode
